/* -----------------Child components--------------- */
import AccountListItem from "./AccountListItem";

import { Card } from "react-native-paper";
import type { FontSchemaType } from "../../font";
import { useDevice } from "../../useDevice";
/* -----------------Types--------------- */
import Box from "../Box";
import { CustomAppBar } from "../CustomAppbar";
import type { CustomAppBarProps } from "../CustomAppbar/types";
import { CustomListSubheader } from "../CustomListSubheader";
import ScrollContainer from "../ScrollContainer";
import type { Section } from "./types";

type Props = {
	sections: Section[];
	showPoweredBy?: boolean;
	font: FontSchemaType;
	isDarkMode: boolean;
	showAudioPlaybackTestDialog: boolean;
	showPaywall?: boolean;
	accountExtendValidity: string;
	hasMoreThanOneExam?: boolean;
	toggleDarkMode: () => void;
	PoweredBy?: () => React.ReactNode;
	toggleAudioPlaybackTestDialog: () => void;
	toggleShowPaywall?: () => void;
	handleNavigateToExamsRoute: () => void;
	customAppBar: CustomAppBarProps;
};

const AccountSettingsApplet = ({
	sections,
	showPoweredBy,
	customAppBar,
	font,
	isDarkMode,
	showAudioPlaybackTestDialog,
	showPaywall,
	accountExtendValidity,
	hasMoreThanOneExam,
	toggleDarkMode,
	toggleAudioPlaybackTestDialog,
	toggleShowPaywall,
	PoweredBy,
	handleNavigateToExamsRoute,
}: Props) => {
	const { isMobile } = useDevice();

	const Wrapper = isMobile ? Box : Card;

	return (
		<>
			<CustomAppBar {...customAppBar} />
			<ScrollContainer maxWidth="sm">
				<Wrapper
					style={{
						marginVertical: 16,
					}}
				>
					<Box gap={16} paddingTop={16}>
						{sections.map(({ sectionTitle, items }) => (
							<Box key={sectionTitle} gap={8}>
								<CustomListSubheader
									style={{
										paddingLeft: 16,
									}}
									font={font}
								>
									{sectionTitle}
								</CustomListSubheader>
								{items.map((view) => (
									<AccountListItem
										key={view.title}
										{...view}
										isDarkMode={isDarkMode}
										showAudioPlaybackTestDialog={showAudioPlaybackTestDialog}
										showPaywall={showPaywall}
										accountExtendValidity={accountExtendValidity}
										hasMoreThanOneExam={hasMoreThanOneExam}
										toggleDarkMode={toggleDarkMode}
										toggleAudioPlaybackTestDialog={
											toggleAudioPlaybackTestDialog
										}
										toggleShowPaywall={toggleShowPaywall}
										handleNavigateToExamsRoute={handleNavigateToExamsRoute}
									/>
								))}
							</Box>
						))}
					</Box>
					{showPoweredBy && PoweredBy && <PoweredBy />}
				</Wrapper>
			</ScrollContainer>
		</>
	);
};

export default AccountSettingsApplet;
